import React from 'react';
import { createCommand } from '@commander-js/extra-typings';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import { renderCommand } from './render-command.js';

export const envSetCommand = (
  services: AstroCommandServices,
  cliVersion: string
) => {
  return createCommand('set')
    .description('Sets environment variable')
    .requiredOption('--key <key>', 'Name of the variable')
    .requiredOption('--value <value>', 'Value of the variable')
    .action(async (opts, command) => {
      const { EnvSetCommand } = await import(
        '../components/EnvSetCommand/index.js'
      );

      const variable = { key: opts.key, value: opts.value };

      await renderCommand(
        command,
        services,
        cliVersion,
        <EnvSetCommand variable={variable} />
      );
    });
};
